<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h3 class="text-lg font-semibold mb-4">Добавить документ</h3>

      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Выберите документ</label>
        <v-select
          :options="availableDocuments"
          label="name"
          :modelValue="selectedDocument"
          @update:modelValue="$emit('update:selectedDocument', $event)"
          placeholder="Выберите документ"
        >
          <template #no-options>
            Нет доступных документов
          </template>
        </v-select>
      </div>

      <p v-if="error" class="text-red-500 text-sm mt-1 mb-4">{{ error }}</p>

      <div class="flex justify-end space-x-2">
        <button
          type="button"
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          @click="$emit('save')"
        >
          Сохранить
        </button>
        <button
          type="button"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
          @click="$emit('close')"
        >
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: { vSelect },
  props: {
    availableDocuments: { type: Array, default: () => [] },
    selectedDocument: { type: Object, default: null },
    error: { type: String, default: '' }
  },
  emits: [
    'update:selectedDocument',
    'save',
    'close'
  ]
};
</script>
